import { ApolloProvider } from "@apollo/client";
import { RouterProvider } from "react-router-dom";

import { apolloClient } from "@/apollo/client";
import { router } from "@/router/router";

export function App() {
  return (
    <ApolloProvider client={apolloClient}>
      <RouterProvider router={router} />
    </ApolloProvider>
  );
}
